import React, { useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import { roleModelGet, } from '../../models/roles/role';
import { responseGet, globalSettings, styles, buttonProcessGet, sendMessageCloseCurrentWindowAsync, processEvaluateGet, languageObjGet, isUndNullEmp, awaitDelay, } from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'currentMethod';

const { app, icons, images, labels, messages, react } = globalSettings;
const { backend, } = app;
const { html: reactHtml, } = react;

export default function RolesAddEdit({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = false,
    role = roleModelGet({}),
    setRole = () => { },
    dtId = '',
    dtRowIndex = 0,
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [descriptionError, setDescriptionError] = useState('');
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnRoleModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnRoleModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnRoleModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // inactive: {
            //     id: 'chkRoleModalEnable',
            //     className: 'icheck-primary d-inline',
            // },
            // inactiveReadOnly: {
            //     id: 'chkRoleModalReadOnly',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCountryesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCountryesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCountryesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCountryesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCountryesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCountryesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCountryesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCountryesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoRoleModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoRoleModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoRoleModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            description: {
                id: 'inputRoleModalDescription',
                className: 'form-control',
            },
        },
        selects: {
            // countries: {
            //     id: 'selRoleModalCountries',
            //     className: 'form-select',
            // },
        },
        spinners: {
            save: {
                id: 'spRoleModalSave',
                className: '',
            },
            back: {
                id: 'spRoleModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region methods (roles)
    const roleAddPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'roleAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                role: role,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlRoles}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            role = response?.result || {};

            $(`#${dtId}`)?.DataTable()?.row?.add([
                role?.description,
                buttonProcessGet({
                    id: role?.id,
                    description: role?.description,
                    showDetails: false,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: processEvaluateGet({
                        object: role,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: processEvaluateGet({
                        object: role,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.delete?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result
            ])?.draw(true);
            //#endregion data save

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const roleEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'roleEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = validateFormData({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                role: role,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlRoles}/${role?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            role = response?.result || {};

            $(`#${dtId}`)?.DataTable()?.row(dtRowIndex)?.data?.([
                role?.description,
                buttonProcessGet({
                    id: role?.id,
                    description: role?.description,
                    showDetails: false,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: false,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: processEvaluateGet({
                        object: role,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: processEvaluateGet({
                        object: role,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.delete?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result
            ])?.draw(true);
            //#endregion data save

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion methods (roles)

    //#region methods (others)
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSet = ({
        property = '',
        value = '',
        subMethod = '',
    }) => {
        const currentMethod = 'formDataSet';
        let response = responseGet();
        try {
            setRole({
                ...role,
                [property]: value,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
    }

    const validateFormData = ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormData';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: role?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const errorsDefaultSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'errorsDefaultSet';
        let response = responseGet();
        try {
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const controlsStatusSet = ({
        processType = 0,
        subMethod = '',
    }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            // $(`#${controls?.inputs?.code?.id}`)?.attr({ readOnly: processType !== 0, });
            // $(`#${controls?.inputs?.rif?.id}`)?.attr({ disabled: processType !== 0, });
            // $(`#${controls?.selects?.countries?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.role?.[languageObj?.id]}
                        src={images?.rolesLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.role?.[languageObj?.id]} ({processType === 0 ?
                            labels?.add?.[languageObj?.id]?.toLowerCase() :
                            processType === 1 ?
                                labels?.edit?.[languageObj?.id]?.toLowerCase() :
                                labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>

            <form onSubmit={(e) => processType === 0 ?
                roleAddPostAsync({ e: e, subMethod: 'form - onSubmit', }) :
                roleEditPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processType === 0 ? roleAddPostAsync(e) : roleEditPostAsync(e)}> */}

                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.role?.[languageObj?.id]} src={images?.rolesLogo} style={styles?.cardHeaderLogo}></img> - {labels?.role?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* <div className='card-body'> */}
                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.description?.id}
                                className={controls?.inputs?.description?.className}
                                placeholder={labels?.name?.[languageObj?.id]}
                                onChange={(e) => formDataSet({
                                    property: 'description',
                                    value: e?.target?.value,
                                    subMethod: 'input - description',
                                })}
                                onFocus={() => setDescriptionError('')}
                                value={role?.description || ''}
                                tooltip='tooltip'
                                title={labels?.name?.[languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={icons?.spellCheck} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                    </div>

                    {/* <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <select defaultValue={role.countryId} className='form-select' onChange={(e) => formDataSet('countryId', e.target.value)} onFocus={() => setCountryIdError('')}>
                                        <option key='nothing' value=''>{labels?.selectCountry}</option>
                                        {countries.map((country) => <option key={country.id} value={country.id}>{country.description}</option>)};
                                    </select>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className='fas fa-globe-americas' />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(countryIdError)}</div>
                            </div> */}
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1'
                                    tooltip='tooltip'
                                    title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowAltCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}